export default class config {
    static get baseUrl() {
        return "";
    }


    // урл папки бэкенда на сайте клиники (слеш обязателен)
    static get dataUrl() {
        return "https://api.xn--d1abbmakcfendimnb3a9d.xn--p1ai/medangel/medangel-backend/"
    }

    // урл политики конфеденциальности на сайте клиники
    static get privateUrl() {
        return "https://docs.google.com/document/d/1iPpg6Pwyw36ysDAUaOrEvxodmpfSxYeRIoc14niMtpg/edit?hl=ru&tab=t.0"
    }


    static get partnerId() {
        return window.nebolitpro._partnerId;
    }

    /* For appointment widget only. */
    static get clinicId() {
        return 5;
    }

    static get scheduleLength() {
        return 7;
    }

    static get yandexMetrikaConfig() {
        return {
            id: 0,
        };
    }
}


/** WEBPACK FOOTER **
 ** ./src/config.js
 **/